import {ReactNode} from 'react'

interface MultiParagraphMessageProps {
    paragraphs: ReactNode[]
}

export const MultiParagraphMessage = ({paragraphs}: MultiParagraphMessageProps) => {
    return (
        <div className="flex flex-col gap-8 [word-break:break-word]">
            {paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
            ))}
        </div>
    )
}
